import React, {PureComponent} from 'react';
import {
  Card, CardBody, Col, Progress,
} from 'reactstrap';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';
import axios from "axios";
import { Draggable } from 'react-beautiful-dnd';

/*<div className="progress-wrap progress-wrap--small progress-wrap--pink-gradient progress-wrap--rounded">
          <p className="dashboard__booking-card-progress-label progress__label">87%</p>
          <Progress value={87} />
        </div>*/

class FastMovingLast extends PureComponent{ 
render(){
    return (
      this.props.report_obj.show == true ?
	<Draggable draggableId={this.props.drag_id} key={this.props.drag_id} index={this.props.index}>
	{(provided, snapshot) => (
  <div 
  className="col-md-12 col-xl-3 col-lg-6 col-xs-12"
  {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref =  {provided.innerRef}
  
  >
    <Card>
      <CardBody className="dashboard__booking-card" style={{background:'#FEF1CC',border:'1px solid #FBBB00',cursor:'move'}}>
        <div className="dashboard__booking-total-container">
          <h5 className="dashboard__booking-total-title" onClick={() => {window.location.href = this.props.report_obj.on_click}} style={{cursor:'pointer',marginBottom: '0.5em'}}>
		  {this.props.report_obj.data_count}
          </h5>
        </div>
        <h5 className="dashboard__booking-total-description" onClick={() => {window.location.href = this.props.report_obj.on_click}} style={{cursor:'pointer'}}>{this.props.report_obj.display_text}</h5>
        
      </CardBody>
    </Card>
  </div>
  )}
  </Draggable>: ''
  
  );
  }
}

export default FastMovingLast;
